import { connect } from 'react-redux'
import VideoPlayerWrapper from '../components/simpleVideoPlayerWrapper.jsx'
import { VideoPlayerActions } from 'aria-viewer/players/videoplayer'

const mapStateToProps = ({ video, ...rest }, ownProps) => {
    return {
        isVideoUIVisible: video ? video.getIn(['isVideoUIVisible']) : false,
        isVideoPlaying: video ? video.getIn(['isVideoPlaying']) : false,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setVideoPlayer: player => dispatch(VideoPlayerActions.setVideoPlayer(player)),
        showVideoUI: (p, isVideoUIVisible) => dispatch(VideoPlayerActions.showSimpleVideoUI(p, isVideoUIVisible)),
        hideVideoUI: isVideoUIVisible => dispatch(VideoPlayerActions.hideSimpleVideoUI(isVideoUIVisible)),
        startHideVideoUITimer: p => dispatch(VideoPlayerActions.startHideVideoUITimer(p)),
        cancelHideVideoUITimer: () => dispatch(VideoPlayerActions.cancelHideVideoUITimer()),
    }
}

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    showVideoUI: p => {
        const isVideoUIVisible = stateProps.isVideoUIVisible
        dispatchProps.showVideoUI(p, isVideoUIVisible)
    },
    hideVideoUI: () => {
        const isVideoUIVisible = stateProps.isVideoUIVisible
        dispatchProps.hideVideoUI(isVideoUIVisible)
    },
})

export default connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(VideoPlayerWrapper)
